/**
 * Helpscout article keys to use the beacon to open articles
 * Go to docs then click on the article and copy the last part of the slug
 * https://secure.helpscout.net/docs/5b0707b40428635ba8b2b54f/
 */
export const HELPSCOUT_ARTICLE_KEYS = Object.freeze({
  // Candidate Stages: Tracking Applicants from Application to Hire
  // https://help.thehiringengine.com/article/17-candidate-stages
  TRACKING_APPLICANTS: '5b70e6b02c7d3a03f89d9b97',
  // Thumbs Up/Thumbs Down Applicants
  TU_TD_APPLICANTS: '5c8ea49a0428633d2cf3b067',

  // Text message template variables
  // https://help.thehiringengine.com/article/36-using-variables-to-personalize-messages
  TEXT_MESSAGE_VARIABLES: '5daf08582c7d3a7e9ae2dc1e',

  // Sending employee messages in English and Spanish
  // https://help.teamengine.io/article/62-sending-employee-messages-in-english-and-spanish
  SENDING_IN_ENGLISH_SPANISH: '61099543b37d837a3d0e061a',
});
